

export default function (e) {
  const firstSection = $('.js-first-section');
  if (firstSection && firstSection.length > 0) {
    setTimeout(() => {
      let collided = collision($('.top-header'), $('.js-first-section'), 100);
      console.log(' collided --', collided)
      if (collided) {
        $('.top-header').addClass('page-scroll');
      } else {
        $('.top-header').removeClass('page-scroll');
      }
    }, 0);

    const $investorStickyMenu = $('.js-investor-sticky-menu');
    if ($investorStickyMenu && $investorStickyMenu.length > 0) {
      setTimeout(() => {
        let collidedMenu = collision($('.top-header'), $('.js-first-section'), 0);

        if (collidedMenu) {
          $investorStickyMenu.addClass('sticky');
        } else {
          $investorStickyMenu.removeClass('sticky');
        }

      }, 0);
    }


    const $logoSquare = $('.js-logo-square');
    if ($logoSquare && $logoSquare.length > 0) {
      setTimeout(() => {
        let logoSquareTopReached = $(window).scrollTop() > $logoSquare.offset().top ? true : false;

        if (logoSquareTopReached) {
          $logoSquare.addClass('sticky');
        } else {
          $logoSquare.removeClass('sticky');
        }
      }, 0);
    }
  }
}


function collision($div1, $div2, change) {
  var x1 = $div1.offset().left;
  var y1 = $div1.offset().top;
  var h1 = $div1.outerHeight(true);
  var w1 = $div1.outerWidth(true);
  var b1 = y1 + h1;
  var r1 = x1 + w1;
  var x2 = $div2.offset().left;
  var y2 = $div2.offset().top;
  var h2 = $div2.outerHeight(true);
  var w2 = $div2.outerWidth(true);
  var b2 = y2 + h2 - change;
  var r2 = x2 + w2 - change;

  if (b1 < y2 || y1 > b2 || r1 < x2 || x1 > r2) return true;
  return false;
}



